import { format, isSameDay, isValid, parse, parseISO } from 'date-fns';
import addDays from 'date-fns/addDays';
import ru from 'date-fns/locale/ru';

export function formatRuSmartDate(
  input: string | Date,
  opts?: { now?: Date } // optional for testing
): string {
  const d = typeof input === 'string' ? parseISO(input) : input;
  if (!isValid(d)) throw new Error('Invalid date');

  const now = opts?.now ?? new Date();

  if (isSameDay(d, now)) return 'Сегодня';
  if (isSameDay(d, addDays(now, -1))) return 'Вчера';

  const s = format(d, 'EEEE   dd.MM.yyyy', { locale: ru }); // e.g. "среда   12.11.2025"
  return s.charAt(0).toUpperCase() + s.slice(1); // -> "Среда   12.11.2025"
}

/**
 * Accepts a string like "14.11.2025" (dd.MM.yyyy),
 * parses it in local timezone at 00:00, then delegates to formatRuSmartDate.
 */
export function formatRuSmartDateFromDMY(
  dateStr: string,
  opts?: { now?: Date } // same option passthrough for testing
): string {
  // strict parse: requires leading zeros in day/month
  let d = parse(dateStr.trim(), 'dd.MM.yyyy', new Date());
  if (!isValid(d)) {
    // optional lenient fallback like "7.5.2025"
    d = parse(dateStr.trim(), 'd.M.yyyy', new Date());
  }
  if (!isValid(d)) {
    throw new Error(`Invalid date string: "${dateStr}" (expected "dd.MM.yyyy")`);
  }
  return formatRuSmartDate(d, { now: opts?.now });
}
